import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import OrdersListBody from "components/PatientManagement/Orders/OrdersListBody";

export default function Orders() {
  useEffect(() => {
    document.title = "Orders";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <OrdersListBody />
    </main>
  );
}
